<template>
  <section
    class="draggable-modules-item-component"
    :class="{ isSubmodule, opened }"
  >
    <button
      class="btn card py-5"
      :class="{
        opened,
        'indicator px-2_5': isSubmodule
      }"
      @click="openContentCard"
    >
      <div class="d-flex align-items-center flex-fill">
        <i class="icon-drag-indicator handle lead pl-3 pr-5"></i>
        <span
          class="module-name text-wrap text-left pr-3"
          :contenteditable="editname"
          @click.stop="onEditName"
          @blur="onBlurName"
          spellcheck="false"
        >
          {{ module.name }}
        </span>
        <span v-if="module.status === 'draft'" class="ml-5 draft-badge">
          Rascunho
        </span>
      </div>
      <i
        class="fa-solid"
        :class="{
          'fa-chevron-up': opened,
          'fa-chevron-down': !opened,
          'mr-3': isSubmodule
        }"
      ></i>
      <div class="d-flex align-items-center justify-content-end">
        <actions-dropdown
          :left="false"
          :right="true"
          :actions="actions"
          @edit="$emit('edit', module)"
          @duplicate="$emit('duplicate', module)"
          @remove="$emit('remove', module)"
          @lesson="goToLesson(module)"
          @submodule="goToSubmodule(module)"
          @clone-lesson="cloneLessonModal = true"
          @quiz="goToQuizz(module)"
          toggleClass="p-0 pr-2"
        >
          <template #button-custom-content>
            <i
              class="icon-more-vertical btn btn-sm"
              :class="{ 'pr-0': !isSubmodule }"
              role="button"
            ></i>
          </template>
        </actions-dropdown>
      </div>
    </button>
    <div
      v-if="opened"
      class="card-body"
      :class="{
        empty: sortedItems.length == 0 && sortedSubModules.length == 0
      }"
    >
      <action-dispatcher
        action="membersModules/getDetails"
        :parameters="module.id"
        @success="onOpenContentModuleContent"
      >
        <draggable-items
          v-if="sortedItems.length"
          v-model="sortedItems"
          show-list-indicator
          :parent="module"
          group="lessons"
          @edit="item => emitSubItemEvent('edit', item)"
          @duplicate="item => emitSubItemEvent('duplicate', item)"
          @remove="item => emitSubItemEvent('remove', item)"
        />
        <div
          class="add-buttons"
          :class="{ only_submodules: !sortedItems.length }"
        >
          <svg height="0" width="33" v-if="sortedSubModules.length">
            <line x1="1" x2="1" y1="0" :y2="'100%'" stroke="#cccee0" />
          </svg>
          <button
            class="btn btn-outline-primary btn-outline-primary-dashed flex-fill"
            @click="goToLesson(module)"
          >
            <i class="fa-solid fa-plus mr-5"></i>
            <span>Nova Aula</span>
          </button>
          <button
            class="btn btn-outline-primary btn-outline-primary-dashed flex-fill"
            @click="goToQuizz(module)"
          >
            <i class="fa-solid fa-plus mr-5"></i>
            <span>Nova Avaliação</span>
          </button>
          <button
            v-if="module.parent === null"
            class="btn btn-outline-primary btn-outline-primary-dashed flex-fill"
            @click="goToSubmodule(module)"
          >
            <i class="fa-solid fa-plus mr-5"></i>
            <span>Novo Submódulo</span>
          </button>
        </div>
        <draggable-items
          v-if="sortedSubModules.length"
          v-model="sortedSubModules"
          show-list-indicator
          :parent="module"
          group="submodules"
          @edit="item => emitSubItemEvent('edit', item)"
          @duplicate="item => emitSubItemEvent('duplicate', item)"
          @remove="item => emitSubItemEvent('remove', item)"
        />
        <!-- <div v-else class="row justify-content-center">
          <div class="col-lg-5 text-center">
            <img
              class="d-block my-6 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <h5>Ainda não há nada aqui</h5>
            <div class="text-secondary mb-5">
              Não há conteúdo cadastrado até o momento.
            </div>
          </div>
        </div> -->
      </action-dispatcher>
    </div>
    <responsive-modal v-model="cloneLessonModal">
      <clone-lesson
        :module="module.id"
        @close="() => (this.cloneLessonModal = false)"
      />
    </responsive-modal>
  </section>
</template>
<script>
import CloneLesson from "@/components/product/details/content/CloneLesson";
import DraggableItems from "@/components/product/details/content/DraggableItems";
import get from "lodash/get";
export default {
  name: "draggable-modules-items",
  components: { DraggableItems, CloneLesson },
  props: {
    isSubmodule: {
      type: Boolean,
      default: false
    },
    module: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const selectedModule = this.$store.state.membersModules.selectedModule;
    return {
      opened:
        this.module.id === selectedModule.parent ||
        this.module.id === selectedModule.id,
      module_data: this.module,
      cloneLessonModal: false,
      editname: false,
      initialName: this.module.name,
      loadingName: false,
      actions: [
        {
          text: this.isSubmodule ? "Editar submódulo" : "Editar módulo",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        {
          text: this.isSubmodule ? "Duplicar submódulo" : "Duplicar módulo",
          class: "",
          icon: "fa-solid fa-clone",
          confirmation: {
            enable: false
          },
          event: "duplicate"
        },
        {
          text: "Nova aula",
          class: "",
          icon: "fa-solid fa-file",
          confirmation: {
            enable: false
          },
          event: "lesson"
        },
        {
          text: "Copiar aula existente",
          class: "",
          icon: "fa-solid fa-clone",
          confirmation: {
            enable: false
          },
          event: "clone-lesson"
        },
        {
          text: "Nova avaliação",
          class: "",
          icon: "fa-solid fa-file-pen",
          confirmation: {
            enable: false
          },
          event: "quiz"
        },
        ...(this.isSubmodule
          ? []
          : [
              {
                text: "Novo submódulo",
                class: "",
                icon: "fa-solid fa-book",
                confirmation: {
                  enable: false
                },
                event: "submodule"
              }
            ]),
        {
          text: "Remover",
          class: "text-danger",
          icon: "fa-solid fa-trash",
          confirmation: {
            enable: true,
            text: this.exclusionMessage(),
            newDesign: true,
            submitText: "Excluir",
            submitButtonClass: "btn-danger"
          },
          event: "remove"
        }
      ]
    };
  },
  computed: {
    sortedItems: {
      get() {
        return [...get(this.module_data, "items", [])]
          .filter(item => item.type !== "submodule")
          .sort((a, b) => a.sort - b.sort);
      },
      set(val) {
        const moduleClone = { ...this.module_data };
        for (let i in val) {
          val[i].sort = i;
        }
        moduleClone.items = val;
        this.module_data = moduleClone;
        this.saveOrderItems();
      }
    },
    sortedSubModules: {
      get() {
        return [...get(this.module_data, "items", [])]
          .filter(item => item.type === "submodule")
          .sort((a, b) => a.sort - b.sort);
      },
      set(val) {
        const moduleClone = { ...this.module_data };
        for (let i in val) {
          val[i].sort = i;
        }
        moduleClone.items = val;
        this.module_data = moduleClone;
        this.saveOrderItems();
      }
    }
  },
  methods: {
    openContentCard() {
      if (!this.editname) {
        this.opened = !this.opened;
      }
    },
    onOpenContentModuleContent(data) {
      this.module_data = data;
      const selectedModule = this.$store.state.membersModules.selectedModule;
      if (selectedModule.parent !== data.id)
        this.$store.commit("membersModules/setSelectedModule", data);
    },
    emitSubItemEvent(event, item) {
      this.$emit(event, { ...item, opened_module_id: this.module_data.id });
    },
    exclusionMessage() {
      if (this.group === "modules")
        return "Tem certeza que deseja excluir esse módulo? Serão excluídos todos os submódulos e aulas do módulo.";
      else if (this.group === "lessons")
        return "Tem certeza que deseja excluir essa aula?";
      else
        return "Tem certeza que deseja excluir esse submódulo? Serão excluídas todas as aulas do submódulo.";
    },
    saveOrderItems() {
      this.$store.dispatch(
        "membersModules/reorderItems",
        this.module_data.items
      );
    },
    goToLesson(item) {
      this.$store.commit("membersModules/setSelectedModule", this.module_data);
      this.$router.push({
        name: "product-members-lesson-add",
        params: {
          id: this.$route.params.id
        },
        query: { module_id: item.id }
      });
    },
    goToQuizz(item) {
      this.$store.commit("membersModules/setSelectedModule", this.module_data);
      this.$router.push({
        name: "product-members-module-quizz-add",
        params: {
          id: this.$route.params.id,
          module_id: item.id
        }
      });
    },
    goToSubmodule(item) {
      this.$store.commit("membersModules/setSelectedModule", this.module_data);
      this.$router.push({
        name: "product-members-submodule-add",
        params: {
          id: this.$route.params.id,
          module_id: item.id
        }
      });
    },
    onKeyDownName(e) {
      if (e.keyCode === 13 || e.which === 13) {
        e.preventDefault();
        this.editname = false;
        return false;
      }
    },
    onEditName() {
      this.editname = true;
      document.addEventListener("keydown", this.onKeyDownName);
    },
    onBlurName(e) {
      if (this.loadingName) return;

      let type = this.isSubmodule ? "submódulo" : "módulo";

      if (!e.target.innerText.trim().length) {
        this.$message.error(`O nome do ${type} não pode ser vazio`);
        e.target.innerText = this.initialName;
      } else if (e.target.innerText.length > 240) {
        this.$message.error(
          `O nome do ${type} não pode ter mais de 240 caracteres`
        );
        e.target.innerText = this.initialName;
      } else {
        const action = this.isSubmodule
          ? "membersModules/putSub"
          : "membersModules/put";
        this.loadingName = true;
        this.$store
          .dispatch(action, { ...this.module, name: e.target.innerText })
          .then(() => {
            this.initialName = e.target.innerText;
            this.$message.success(`O novo nome do ${type} foi salvo`);
          })
          .finally(() => {
            this.loadingName = false;
          });
      }
      this.editname = false;
      document.removeEventListener("keydown", this.onKeyDownName);
    }
  }
};
</script>
<style lang="scss" scoped>
.draggable-modules-item-component {
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--l-strokes-card, #d2d4df);
  background: var(--l-elevation-4, rgba(255, 255, 255, 0.16));
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
  transition: 0.3s ease-in;
  &.isSubmodule {
    &.opened {
      box-shadow: none;
    }

    .card-body {
      padding: 16px 0 0 0;
    }
  }

  .px-2_5 {
    padding-right: 0.15rem;
    padding-left: 0.15rem;
  }

  a,
  a:hover {
    text-decoration: none;
  }
  .icon-drag-indicator {
    cursor: pointer;
    color: rgba(184, 186, 204, 0.855);

    &:active {
      cursor: grap;
    }
  }

  .icon-angle-down {
    font-size: 19px;
  }

  .card {
    border-radius: 4px;
    // border: 1px solid var(--l-strokes-card, #d2d4df) !important;
    border: 1px solid transparent;
    background: var(--l-elevation-4, rgba(255, 255, 255, 0.16)) !important;
    width: 100%;
    display: flex !important;
    flex-direction: row;
    position: relative;

    &.opened {
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08) !important;
    }

    &:hover {
      border: 1px solid rgba(207, 174, 255, 0.86);
    }
  }

  .module-name {
    color: rgba(59, 59, 74, 0.9) !important;
    font-size: 14px;
    font-weight: 400 !important;
    max-width: 70%;
    overflow-wrap: anywhere;
  }

  .card-body {
    position: relative;
    transition: 0.2s all;
    &:not(.empty) {
      padding-left: 12px;
      @media screen and (min-width: 576px) {
        padding-left: 80px;
      }
    }
  }

  ::v-deep.add-buttons {
    display: flex !important;
    flex-direction: row;
    justify-content: space-between;
    padding: 12px 0px;
    gap: 12px;

    @media screen and (max-width: 991px) {
      flex-direction: column;
    }

    svg {
      @media screen and (max-width: 575px) {
        display: none;
      }

      left: 28.49px;
      position: absolute;
      width: 33px;
      height: 140px;
      margin-top: -60px;
      @media screen and (max-width: 991px) {
        height: 250px !important;
      }
    }
    &.only_submodules {
      svg {
        @media screen and (max-width: 575px) {
          display: none;
        }

        height: 100px !important;
        margin-top: -16px !important;
        @media screen and (max-width: 991px) {
          height: 220px !important;
        }
      }
    }
  }
}
</style>
